<template>
    <div class="wrapper justify-center row">
        <template>
            <main-content-wrapper class="login" v-if="application_type == 'HN' || application_type=='SPD'">
                <h1 class="text-md-center" v-if="application_type == 'HN'">
                    Že imate Hitri nakup ali Tuš klub račun?
                    <span class="subtitle">Če imate Tuš Klub račun se enostavno prijavite z istimi podatki.</span>
                </h1>
                <h1 class="text-md-center" v-if="application_type=='SPD'">
                    Že imate Spletna drogerija ali Tuš klub račun?
                    <span class="subtitle">Če imate Tuš Klub račun se enostavno prijavite z istimi podatki.</span>
                </h1>
                <v-btn depressed large block @click="login" :loading="loading">PRIJAVITE SE</v-btn>
            </main-content-wrapper>
            <div class="break">&nbsp;</div>
        </template>
        <main-content-wrapper>
            <template>
                <h1 class="text-md-center" v-if="application_type == 'HN' || application_type == 'SPD'">Ustvarite nov račun</h1>
                <h1 class="text-md-center" v-else>Registracija v Tuš klub profil</h1>
            </template>
            <split-content text="Prijavni podatki" v-if="application_type == 'HN' || application_type == 'SPD'" />
            <empty-space />
            <v-flex xs12 sm12>
                <v-form v-model="valid" @submit.prevent="" ref="form">
                    <v-alert
                            v-if="application_type != 'HN' && application_type != 'SPD'"
                            :value="invalid_no_cond"
                            type="error"
                    >
                        Za nadaljevanje se je potrebno strinjati s politiko zasebnosti in pravnim obvestilom.
                    </v-alert>
                    <v-alert
                            :value="create_account_problem"
                            type="error"
                    >
                        {{ create_account_problem_msg }}
                    </v-alert>
                    <empty-space v-if="invalid_no_cond||create_account_problem" />
                    <input-field v-if="!allow_join_club" v-model="name" label="Ime" :rules="checkNameLastnameRules" required autofocus prepend-inner-icon="fa-user" />
                    <email-field v-model="email" label="Vpišite vaš e-naslov" :error-messages="email_error_messages" :rules="[checkEmail]" ref="email_input" required />
                    <password-field v-model="password" :rules="newPasswordRules" label="Izberite geslo" required/>
                    <password-field v-model="password_again" :rules="[checkNewPasswordAgain]" label="Ponovno vpišite geslo" required/>
                    <v-checkbox
                            v-model="confirm_cond"
                            required
                            v-if="application_type != 'HN' && application_type != 'SPD'"
                    >
                        <div slot="label">
                            Strinjam se s <a target="_blank" href="https://www.tus.si/politika-zasebnosti/" v-on:click.stop="" class="terms">politiko zasebnosti</a> in <a target="_blank"  v-on:click.stop="" href="https://www.tus.si/pravno-obvestilo">pravnim
                            obvestilom</a>.
                        </div>
                    </v-checkbox>
                <template v-if="application_type == 'HN' || application_type == 'SPD'">
                    <split-content text="Privolitve in načini obveščanja" />
                    <empty-space />
                    <v-flex xs12 class="pa-2">
                        <v-checkbox
                                v-model="confirm_all_consents"
                                color="primary"
                                required
                        >
                            <div slot="label">
                                Strinjam se z vsemi spodaj opredeljenimi nameni obdelovanja osebnih podatkov ter kanali obveščanja.
                            </div>
                        </v-checkbox>
                        <v-alert
                                :value="invalid_no_cond"
                                type="error"
                        >
                            Za nadaljevanje se je potrebno strinjati s pogoji uporabe.
                        </v-alert>
                        <v-checkbox
                                v-model="confirm_cond"
                                color="primary"
                                required
                        >
                            <div slot="label">
                                <template v-if="application_type == 'HN'">
                                    Potrjujem, da sem prebral/a <a href="" class="terms">splošne pogoje storitve Hitri Nakup</a> ter jih razumem in se z njimi strinjam.
                                </template>
                                <template v-if="application_type == 'SPD'">
                                    Potrjujem, da sem prebral/a <a target="_blank" href="https://www.tusdrogerija.si/splosni-pogoji/" class="terms">splošne pogoje Spletne drogerije</a> ter jih razumem in se z njimi strinjam.
                                </template>
                            </div>
                        </v-checkbox>
                    </v-flex>
                </template>
                </v-form>
            </v-flex>
            <v-btn depressed large block color="primary_action" @click="createAccount" :loading="loading">POTRDI</v-btn>
            <v-layout justify-center row wrap v-if="application_type == 'HN' || application_type == 'SPD'">
                <v-flex xs12 sm6 class="pa-2">
                    <v-btn class="consents-toggle" text @click="show_consents=!show_consents"><v-icon v-if="!show_consents">fas fa-angle-down</v-icon><v-icon v-if="show_consents">fas fa-angle-up</v-icon> Posamezne privolitve</v-btn>
                    <consents v-if="show_consents" vuex_module="registration" />
                </v-flex>
                <v-flex xs12 sm6 class="pa-2">
                    <v-btn class="consents-toggle" text @click="show_consents_channels=!show_consents_channels"><v-icon v-if="!show_consents_channels">fas fa-angle-down</v-icon><v-icon v-if="show_consents_channels">fas fa-angle-up</v-icon> Kanali za obveščanje</v-btn>
                    <consents-channels v-if="show_consents_channels" vuex_module="registration" />
                </v-flex>
            </v-layout>
        </main-content-wrapper>
    </div>
</template>

<script>
    import MainContentWrapper from "../components/MainContentWrapper";
    import SplitContent from "../components/SplitContent";
    import PasswordField from "../components/PasswordField";
    import EmailField from "../components/EmailField";
    import EmptySpace from "../components/EmptySpace";
    import utils from "../store/utils";
    import validations from "../components/validations";
    import {userService} from "../services";
    import InputField from "../components/InputField";
    import Router from '../router';
    import Consents from "../components/Consents";
    import ConsentsChannels from "../components/ConsentsChannels";

    export default {
        name: "CreateAccount",
        data: vm => ({
            valid: false,
            invalid_no_cond: false,
            confirm_cond: false,
            newPasswordRules: validations.newPasswordRules,
            checkNameLastnameRules: validations.checkNameLastname,
            email_error_messages: [],
            show_consents: false,
            show_consents_channels: false
        }),
        computed: {
            name: utils.vuexBuildSetGet(this, 'registration', 'personal.name'),
            email: utils.vuexBuildSetGet(this, 'registration', 'account.email'),
            password: utils.vuexBuildSetGet(this, 'registration', 'account.password'),
            password_again: utils.vuexBuildSetGet(this, 'registration', 'account.password_again'),
            create_account_problem: utils.vuexBuildSetGet(this, 'auth', 'create_account_problem'),
            create_account_problem_msg: utils.vuexBuildSetGet(this, 'auth', 'create_account_problem_msg'),
            allow_join_club: utils.vuexBuildSetGet(this, 'application', 'allow_join_club'),
            loading: utils.vuexBuildSetGet(this, 'auth', 'loading'),
            application_type: utils.vuexBuildSetGet(this, 'application', 'application_type'),
            confirm_all_consents: utils.vuexBuildSetGet(this, 'registration', 'confirm_all_consents', 'registration/confirmAllConsents'),
        },
        components: {SplitContent, EmailField, PasswordField, EmptySpace, MainContentWrapper, InputField, Consents, ConsentsChannels},
        mounted() {
            this.$trackPageVisit('create-account');
        },
        methods: {
            login(){
                Router.push('/')
            },
            createAccount() {
                let isValid = this.$refs.form.validate();
                this.invalid_no_cond = this.confirm_cond == false;
                if (isValid && this.invalid_no_cond == false) {
                    this.loading = true;
                    this.$store.dispatch('auth/createAccount', {username: this.email, password: this.password, name: this.name});
                }
            },
            checkNewPasswordAgain(v) {
                return validations.newPasswordCheckAgain(v, this.password);
            },
            checkEmail(v){
                this.email_error_messages = [];
                let noError = validations.checkEmailAll(v);
                if (noError === true){
                    if (this.$refs['email_input'].hasError == false) {
                        userService.checkEmail(v).then(
                            data => {

                            },
                            error => {
                                if (error.message) {
                                    this.email_error_messages = [error.message];
                                } else {
                                    this.email_error_messages = ['Napaka pri preverjanju naslova.'];
                                }
                            }
                        );
                    }
                    return true;
                }
                return noError;
            }
        }
    }
</script>

<style scoped>
.login {
    padding-bottom: 30px !important;
}

.wrapper {
    display: flex;
    flex-wrap: wrap;
    width: 100%;

}
.wrapper .break {
    flex-basis: 100%;
    height: 30px;
}
</style>